import {
    parseBoolean,
    parseOptionalEnum,
    parseRequiredString
} from './datasetParsers';
import {DATA_ATTRIBUTES, ENVIRONMENTS, PAGE_TYPES, PROTOCOLS} from '../types';
import {loadAndMountForm} from './loadAndMountForm';


export function autoload(): void {
    const formContainers = document.querySelectorAll<HTMLElement>('.bff-form');

    formContainers.forEach((container) => {
        const dataset = container.dataset;

        void loadAndMountForm({
            container: container,
            network: parseRequiredString(dataset, DATA_ATTRIBUTES.NETWORK),
            property: parseRequiredString(dataset, DATA_ATTRIBUTES.PROPERTY),
            pageId: parseRequiredString(dataset, DATA_ATTRIBUTES.PAGE_ID),
            pageType: parseOptionalEnum(dataset, DATA_ATTRIBUTES.PAGE_TYPE, PAGE_TYPES),
            isPreview: parseBoolean(dataset, DATA_ATTRIBUTES.IS_PREVIEW),
            setPageTitle: parseBoolean(dataset, DATA_ATTRIBUTES.SET_PAGE_TITLE),
            bootstrapOnly: parseBoolean(dataset, DATA_ATTRIBUTES.BOOTSTRAP_ONLY),
            viewClone: parseBoolean(dataset, DATA_ATTRIBUTES.VIEW_CLONE),
            protocol: parseOptionalEnum(dataset, DATA_ATTRIBUTES.PROTOCOL, PROTOCOLS),
            env: parseOptionalEnum(dataset, DATA_ATTRIBUTES.ENV, ENVIRONMENTS)
        });
    });
}
